import {
  useCheckRoles,
  useMediaQuery,
  useAPlayerStatus,
  useInviteGuest,
} from 'hooks';
import React, { useState } from 'react';
import { LocationSelectors } from 'view/molecules/LocationSelectors/LocationSelectors';
import { useNavigate } from 'react-router';
import { UserRole } from 'interfaces';
import { Icon, Text } from 'view/atoms';
import { ROUTES } from 'config';
import { exit, plus, inviteUser } from 'static/icons/resizable';
import { useTranslation } from 'react-i18next';
import {
  InviteGuestModal,
  LogoutModal,
  NotificationButton,
  ProfileLanguageSelector,
} from './components';
import * as S from './ProfileMenu.styles';

type Props = {
  logoutModalRef?: React.Ref<HTMLDivElement>;
  inviteModalRef?: React.Ref<HTMLDivElement>;
};

export const ProfileMenu = ({ logoutModalRef, inviteModalRef }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mobile, tablet } = useMediaQuery();
  const isMobile = mobile || tablet;

  const isAPlayer = useAPlayerStatus();
  const [isCitySelected, setIsCitySelected] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const {
    handleInvite,
    showInviteModal,
    closeModal,
    aPlayerState,
    reloadState,
  } = useInviteGuest();

  const showLanguageSelector = isMobile;
  const showNotificationButton =
    useCheckRoles(
      UserRole.User,
      UserRole.Mod,
      UserRole.Super,
      UserRole.Admin,
    ) && isMobile;

  const onNotificationClick = () => {
    navigate(ROUTES.profileNotifications);
  };

  return (
    <>
      <S.ButtonContainer>
        <LocationSelectors
          includeLocationIcons
          checkSelection={setIsCitySelected}
        />
        {isAPlayer && isCitySelected && (
          <S.InviteButton onClick={handleInvite}>
            <Icon src={inviteUser} alt='invite guest icon' />
            <Text kind='body'>{t('aPlayerPage.inviteGuest.buttonLabel')}</Text>
            <Icon src={plus} alt='plus icon' />
          </S.InviteButton>
        )}
        {showNotificationButton && (
          <NotificationButton onClick={onNotificationClick} />
        )}
        {showLanguageSelector && <ProfileLanguageSelector />}
      </S.ButtonContainer>

      <S.ExitButton
        type='button'
        kind='secondary'
        onClick={() => setShowLogoutModal(true)}
      >
        <Icon src={exit} alt='exit' />
        <Text kind='button' color='red1'>
          {t('profile.exitProfile')}
        </Text>
      </S.ExitButton>

      {showLogoutModal && (
        <LogoutModal
          modalRef={logoutModalRef}
          closeHandler={() => setShowLogoutModal(false)}
        />
      )}

      {showInviteModal && (
        <InviteGuestModal
          closeHandler={closeModal}
          onSuccess={reloadState}
          history={aPlayerState?.history}
          modalRef={inviteModalRef}
        />
      )}
    </>
  );
};
